import React, { useCallback, useRef, useState } from "react";
import { Typography } from "@mui/material";
import { StyledAltMarker, StyledTooltip } from "./styles";
import SchedulerColumnTooltip from "./SchedulerColumnTooltip";
import { getAltMetric, isOverBar } from "./helper";

const SchedulerColumnWrapper = ({
  column,
  children,
  isDragging = false,
}) => {
  const [open, setOpen] = useState(false);
  const timer = useRef(null);

  const handleEnter = useCallback((e) => {
    clearTimeout(timer.current);
    if (isOverBar(e)) return;
    timer.current = setTimeout(() => setOpen(true), 600);
  }, []);

  const handleMove = useCallback((e) => {
    if (isOverBar(e)) {
      clearTimeout(timer.current);
      setOpen(false);
    }
  }, []);

  const handleLeave = useCallback(() => {
    clearTimeout(timer.current);
    setOpen(false);
  }, []);

  const { altGoal, altPct, altPosition, altLabel } = getAltMetric(column);

  return (
    <StyledTooltip
      title={<SchedulerColumnTooltip {...column} />}
      open={open && !isDragging}
      disableHoverListener
      followCursor
    >
      <div
        style={{ width: "100%", height: "100%", position: "relative" }}
        onMouseEnter={handleEnter}
        onMouseMove={handleMove}
        onMouseLeave={handleLeave}
      >
        {children}
        {altGoal > 0 && (
          <StyledAltMarker style={{ bottom: `${altPosition}%` }}>
            <Typography variant="caption" className="alt-label">
              {altLabel} {Math.round(altPct)}%
            </Typography>
          </StyledAltMarker>
        )}
      </div>
    </StyledTooltip>
  );
};

export default SchedulerColumnWrapper;
